import { Color } from '@/common/colors/colors';
import styled from 'styled-components';

export const TopWrapper = styled.div`
	display: flex;
	flex-direction: column;
	background: #f4f6f8;
	justify-content: space-around;
	align-items: center;
	padding-bottom: 50px;
	box-sizing: border-box;
	max-width: 1200px;

	width: 100%;
	height: 100%;
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 15px;
	color: ${Color.DarkPurple};
	width: 100%;
	max-width: 875px;
	margin: 0 auto;
`;

export const Title = styled.div`
	font-size: 24px;
	font-weight: 700;
`;

export const Duration = styled.div`
	font-size: 12px;
	font-weight: 400;
	color: #8477af;
`;

export const Card = styled.div`
	background-color: white;
	border-radius: 8px;
	min-height: 50px;
	width: 84%;
	padding: 14px 15px;
	display: flex;
	flex-direction: column;
	gap: 5px;

	color: #29185e;
	font-family: 'Work Sans';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 123.5%; /* 17.29px */
	letter-spacing: 0.28px;

	@media (min-width: 768px) {
		gap: 12px;
	}
`;

export const CardTitle = styled.div`
	color: #29185e;
	font-size: 14px;
	font-style: normal;
	font-weight: 700;

	@media (min-width: 768px) {
		text-align: center;
	}
`;

export const BackButton = styled.div`
	width: 12px;
	aspect-ratio: 1;
	background-color: #edeffe;
	padding: 7px;
	display: flex;
	justify-content: center;
	align-items: center;

	position: absolute;
	right: -45vw;
	top: -20px;
	z-index: 10;
	border-radius: 50%;

	@media (min-width: 768px) {
		right: -380px;
		top: 20px;
	}
`;

export const Roles = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	align-items: center;
	gap: 20px;
`;

export const Role = styled.div<{ color: string }>`
	background-color: ${(props) => props.color};
	border-radius: 8px;
	width: 100%;
	height: 100px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	font-size: 12px;
	line-height: 16px;
`;

export const RoleImage = styled.img`
	width: 50px;
	border-radius: 50%;
`;

export const PlayerName = styled.div`
	font-weight: 700;
	margin-top: 4px;
`;

export const RoleName = styled.div``;

export const Description = styled.div``;

export const TaskList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;

	@media (min-width: 768px) {
		gap: 20px;
	}
`;

export const Task = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 10px;
`;

export const TaskCounter = styled.div`
	display: flex;
	height: 10px;
	aspect-ratio: 1;
	padding: 6px;
	justify-content: center;
	align-items: center;
	border-radius: 24px;
	background: linear-gradient(220deg, #4322c6 28.95%, #48068a 74.94%);
	color: white;
	text-align: center;
`;

export const RelativeAnchor = styled.div`
	width: 0;
	height: 0;
	position: relative;
	overflow: visible;
	justify-self: flex-end;
`;
